import {headerName} from '@telstra-connect/mobile-data-usage-meter/helpers/common-static-data'
import Skeleton from 'telstra-ui/components/skeleton/Skeleton'
import Spacing from '@able/react/dist/Spacing'
import Column from '@able/react/dist/Column'

const SkeletonScreen = () => <Skeleton count={1} height="20px" width="140px" />

const renderGroupItem = (label) => {
  return (
    <div className="tc-mobility-details-group-block">
      <div className="tc-mobility-details-group-heading">
        <h4 className="tc-mobility-details-group-heading-title">{label}</h4>
      </div>
      <div className="tc-mobility-details-group-item">
        <>
          <div className="tc-mobility-details-group-items-block">
            <div className="tc-mobility-details-item-label">{<SkeletonScreen />}</div>
            <div className="tc-mobility-details-item-value">{<SkeletonScreen />}</div>
          </div>
        </>
      </div>
    </div>
  )
}

const AustralianUsage = () => {
  const AUSTRALIAN_DATA_USAGE = 'Australian data usage'
  return (
    <div className="tc-mobility-details-group-block">
      <div className="tc-mobility-details-group-heading">
        <h4 className="tc-mobility-details-group-heading-title">{AUSTRALIAN_DATA_USAGE}</h4>
      </div>
      <div className="tc-mobility-details-group-item">
        <>
          <div className="tc-mobility-details-group-items-block">
            <SkeletonScreen />
            <Column cols={6}>
              <Skeleton />
            </Column>
            <Spacing top="spacing5x">
              <SkeletonScreen />
            </Spacing>
            <Column cols={6}>
              <Skeleton />
            </Column>
          </div>
        </>
      </div>
    </div>
  )
}

const InternationalUsage = () => {
  return (
    <div className="tc-mobility-details-group-block">
      <div className="tc-mobility-details-group-heading">
        <h4 className="tc-mobility-details-group-heading-title">International data usage</h4>
      </div>
      <div className="tc-mobility-details-group-item">
        <>
          <div className="tc-mobility-details-group-items-block">
            <SkeletonScreen />
            <Column cols={6}>
              <Skeleton />
            </Column>
            <Spacing top="spacing5x">
              <SkeletonScreen />
            </Spacing>
            <Column cols={6}>
              <Skeleton />
            </Column>
          </div>
        </>
      </div>
    </div>
  )
}

export const UsageLazyLoadingComponent = () => {
  return (
    <div className="tc-mobility-general-info-block hidden-xs">
      <div className="tc-mobility-web-service-details__header">
        <h3 className="tc-mobility-web-service-details-heading">{headerName.dataUsageDetails}</h3>
      </div>
      <div className="tc-mobility-web-service-details__item-block">
        {renderGroupItem('Add-ons')}
        <AustralianUsage />
        <InternationalUsage />
        {/* {renderGroupItem('International roaming day pass')} */}
        {/* {renderGroupItem('International allowance')} */}
        {/* {renderGroupItem('Usage and activity log')} */}
      </div>
    </div>
  )
}
